import type { ActionFormationDTO, FormationDTO, LovAfDTO } from '@/features/api/extranet/dto/Demande/AF'
import { buildDemandeService } from '../buildDemandeService'

export default buildDemandeService<ActionFormationDTO, LovAfDTO>({
  dispositif: 'AF',
  normaliserData: normaliserData,
})

function normaliserData(data: ActionFormationDTO) {
  data.fichiers ??= []

  data.employeur ??= {} as any
  data.employeur!.contact ??= {} as any
  data.employeur!.etablissement ??= {} as any
  data.employeur!.etablissement!.adresse ??= {} as any

  data.salaries ??= []

  data.formation = data.formation ?? ({} as FormationDTO)
  data.formation!.modules ??= [] as any
  return data
}
